var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53275 12.7978C6.19254 12.7978 5.86627 12.9329 5.62571 13.1735C5.38515 13.414 5.25 13.7403 5.25 14.0805C5.24999 16.1789 6.00408 18.2074 7.37479 19.7962C8.7455 21.385 10.6415 22.4284 12.7173 22.736V24.9673C12.7173 25.3075 12.8524 25.6337 13.093 25.8743C13.3335 26.1149 13.6598 26.25 14 26.25C14.3402 26.25 14.6665 26.1149 14.907 25.8743C15.1476 25.6337 15.2827 25.3075 15.2827 24.9673V22.736C17.3585 22.4284 19.2545 21.385 20.6252 19.7962C21.9959 18.2074 22.75 16.1789 22.75 14.0805C22.75 13.9119 22.7168 13.745 22.6523 13.5893C22.5878 13.4335 22.4932 13.292 22.374 13.1728C22.2548 13.0536 22.1133 12.9591 21.9576 12.8946C21.8019 12.8301 21.6349 12.7969 21.4664 12.7969C21.2978 12.7969 21.1309 12.8301 20.9752 12.8946C20.8194 12.9591 20.6779 13.0536 20.5587 13.1728C20.4395 13.292 20.345 13.4335 20.2805 13.5893C20.216 13.745 20.1827 13.9119 20.1827 14.0805C20.1827 15.7203 19.5314 17.2929 18.3719 18.4524C17.2124 19.6119 15.6398 20.2633 14 20.2633C12.3602 20.2633 10.7876 19.6119 9.62814 18.4524C8.46865 17.2929 7.81725 15.7203 7.81725 14.0805C7.81725 13.9119 7.78401 13.745 7.71944 13.5892C7.65487 13.4335 7.56022 13.292 7.44092 13.1728C7.32162 13.0537 7.18001 12.9593 7.02417 12.8949C6.86834 12.8305 6.70135 12.7975 6.53275 12.7978Z",
    fill: "url(#paint0_linear_1053_24833)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53275 12.7978C6.19254 12.7978 5.86627 12.9329 5.62571 13.1735C5.38515 13.414 5.25 13.7403 5.25 14.0805C5.24999 16.1789 6.00408 18.2074 7.37479 19.7962C8.7455 21.385 10.6415 22.4284 12.7173 22.736V24.9673C12.7173 25.3075 12.8524 25.6337 13.093 25.8743C13.3335 26.1149 13.6598 26.25 14 26.25C14.3402 26.25 14.6665 26.1149 14.907 25.8743C15.1476 25.6337 15.2827 25.3075 15.2827 24.9673V22.736C17.3585 22.4284 19.2545 21.385 20.6252 19.7962C21.9959 18.2074 22.75 16.1789 22.75 14.0805C22.75 13.9119 22.7168 13.745 22.6523 13.5893C22.5878 13.4335 22.4932 13.292 22.374 13.1728C22.2548 13.0536 22.1133 12.9591 21.9576 12.8946C21.8019 12.8301 21.6349 12.7969 21.4664 12.7969C21.2978 12.7969 21.1309 12.8301 20.9752 12.8946C20.8194 12.9591 20.6779 13.0536 20.5587 13.1728C20.4395 13.292 20.345 13.4335 20.2805 13.5893C20.216 13.745 20.1827 13.9119 20.1827 14.0805C20.1827 15.7203 19.5314 17.2929 18.3719 18.4524C17.2124 19.6119 15.6398 20.2633 14 20.2633C12.3602 20.2633 10.7876 19.6119 9.62814 18.4524C8.46865 17.2929 7.81725 15.7203 7.81725 14.0805C7.81725 13.9119 7.78401 13.745 7.71944 13.5892C7.65487 13.4335 7.56022 13.292 7.44092 13.1728C7.32162 13.0537 7.18001 12.9593 7.02417 12.8949C6.86834 12.8305 6.70135 12.7975 6.53275 12.7978Z",
    fill: "url(#paint1_linear_1053_24833)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5C12.8397 3.5 11.7269 3.96094 10.9064 4.78141C10.0859 5.60188 9.625 6.71468 9.625 7.875V14C9.625 15.1603 10.0859 16.2731 10.9064 17.0936C11.7269 17.9141 12.8397 18.375 14 18.375C15.1603 18.375 16.2731 17.9141 17.0936 17.0936C17.9141 16.2731 18.375 15.1603 18.375 14V7.875C18.375 6.71468 17.9141 5.60188 17.0936 4.78141C16.2731 3.96094 15.1603 3.5 14 3.5Z",
    fill: "url(#paint2_linear_1053_24833)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1053_24833",
    x1: 14,
    y1: 12.7978,
    x2: 14,
    y2: 26.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1053_24833",
    x1: 5.25,
    y1: 7.133,
    x2: 13.5747,
    y2: 27.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70777D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1053_24833",
    x1: 14,
    y1: 3.5,
    x2: 14,
    y2: 18.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818CF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.8dbabb1aef1ebed68b5792ac5dae0e54.svg";
export { ForwardRef as ReactComponent };